declare global {
  interface Grecaptcha {
    ready(cb: () => void): void;
    execute(siteKey: string, options: { action: string }): Promise<string>;
  }

  interface Window {
    grecaptcha: Grecaptcha;
  }
}

let recaptchaReadyPromise: Promise<void> | null = null;

export function loadRecaptcha(siteKey: string): Promise<void> {
  if (recaptchaReadyPromise) {
    return recaptchaReadyPromise;
  }

  recaptchaReadyPromise = new Promise((resolve, reject) => {
    if (window.grecaptcha) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      if (!window.grecaptcha) {
        reject(new Error("reCAPTCHA failed to load"));
        return;
      }

      window.grecaptcha.ready(() => resolve());
    };

    script.onerror = reject;
    document.head.appendChild(script);
  });

  return recaptchaReadyPromise;
}
